import React from "react"

export default () => {
  return (
    <ul id="socials-list">
      <li>
        <a className="waves-effect" href="https://github.com/meddion">
          Github
        </a>
      </li>
      <li>
        <a className="waves-effect" href="https://t.me/Medionn">
          Telegram
        </a>
      </li>
    </ul>
  )
}
